import React, { Component } from 'react';
import { Redirect, Route } from 'react-router'


export class RetroUniversum extends Component {
    constructor(props) {
        super(props);

    }

    render() {
        return (
            <Route>
                <Redirect to="https://exchangeovh.icyteg.edu.mx/universum/" />
            </Route>

        )
    }
}
export default RetroUniversum;


// WEBPACK FOOTER //
// ./src/components/RetroUniversum.js